
import { BoxIRemotePage } from "./index.box";
import { CloudIRemotePage } from "./index.cloud";
import { DemoIRemotePage } from "./index.demo";

import { mixin } from "@cems-eco/core/src/utils/platform";
import environment from "@/config";

export default class MaintenanceIndex extends mixin(environment.nexus, {
  box: BoxIRemotePage,
  cloud: CloudIRemotePage,
  demo: DemoIRemotePage,
}) {
  [key: string]: any;
}
